<header class="page-header">
	<h2>Funding Methods</h2>
</header>
<div class="grid grid-cols-12 gap-4 h-full [&>div]:pb-8 mt-10">
	<ui-section title="Trust Accounts" [uiColSpan]="6">
		<ui-button
			actions
			(click)="create(DrawerType.TRUST_ACCOUNT)"
			label="Add Trust Account"
			icon="plus"
		/>
		<ng-container section-content>
			<div class="flex flex-wrap gap-4">
				<ui-card
					*ngFor="
						let trustAccount of trustAccounts$ | async;
						trackBy: trackById
					"
				>
					<ui-content-header
						card-header
						[title]="trustAccount.nickname"
						type="sub-section"
					>
						<ui-button
							actions
							(click)="edit(DrawerType.TRUST_ACCOUNT, trustAccount.id)"
							icon="edit"
							preset="ICON_DEFAULT"
							size="sm"
						></ui-button>
					</ui-content-header>
					<div card-content uiInfoRowList>
						<ui-info-row
							infoIcon="user-square-rounded"
							infoLabel="Account Name"
							[infoValue]="trustAccount.payeeName"
						/>
						<ui-info-row
							infoIcon="building-bank"
							infoLabel="Institution"
							[infoValue]="trustAccount.institutionName"
						/>
						<ui-info-row
							infoIcon="hash"
							infoLabel="Institution Number"
							[infoValue]="trustAccount.institutionNumber"
						/>
						<ui-info-row
							infoIcon="hash"
							infoLabel="Transit Number"
							[infoValue]="trustAccount.transit"
						/>
					</div>
				</ui-card>
			</div>
		</ng-container>
	</ui-section>
	<ui-section [uiColSpan]="6" title="Local Branch">
		<ui-button
			actions
			(click)="create(DrawerType.LOCAL_BRANCH)"
			label="Add Local Branch"
			icon="plus"
		/>
		<ng-container section-content>
			<div class="flex flex-wrap gap-4">
				<ui-card
					*ngFor="let localBranch of localBranches$ | async; trackBy: trackById"
				>
					<ui-content-header
						card-header
						[title]="localBranch.name"
						type="sub-section"
					>
						<ui-button
							actions
							(click)="edit(DrawerType.LOCAL_BRANCH, localBranch.id)"
							icon="edit"
							preset="ICON_DEFAULT"
							size="sm"
						></ui-button>
					</ui-content-header>
					<div card-content uiInfoRowList>
						<ui-info-row
							infoIcon="building-bank"
							infoLabel="Institution"
							[infoValue]="localBranch.name"
						></ui-info-row>
						<ui-info-row
							infoIcon="hash"
							infoLabel="Institution Number"
							[infoValue]="localBranch.institutionNumber"
						></ui-info-row>
						<ui-info-row
							infoIcon="hash"
							infoLabel="Transit Number"
							[infoValue]="localBranch.transitNumber"
						></ui-info-row>
						<ui-info-row infoIcon="map-pin" infoLabel="Address">
							<p class="p">
								{{ localBranch.address | address: 'short' }}<br />{{
									localBranch.address | address: 'cityProvincePostalCode'
								}}
							</p>
						</ui-info-row>
					</div>
				</ui-card>
			</div>
		</ng-container>
	</ui-section>
</div>

<mat-drawer-container
	[hasBackdrop]="true"
	class="fixed h-screen w-full z-modal top-0 right-0"
	[ngClass]="{ 'pointer-events-none': isFullyClosed }"
>
	<mat-drawer
		#drawer
		mode="over"
		position="end"
		(openStart)="openDrawer()"
		(closedStart)="closeDrawer()"
	>
		<ng-container *ngIf="!isFullyClosed">
			<div class="px-6 py-4 h-full" [ngSwitch]="currentDrawer">
				<app-add-edit-trust-account
					*ngSwitchCase="DrawerType.TRUST_ACCOUNT"
					[trustAccountId]="id"
					(onClose)="drawer.close()"
				></app-add-edit-trust-account>
			</div>
		</ng-container>
	</mat-drawer>
</mat-drawer-container>
